import { useTranslation } from "react-i18next";
import { useLangFont } from "../../../hooks/useLangFont";

const brands = ["HERMÈS", "CHANEL", "LOUIS VUITTON", "DIOR", "GUCCI", "PRADA", "CÉLINE", "LOEWE", "BOTTEGA VENETA", "SAINT LAURENT", "BALENCIAGA", "FENDI", "VALENTINO", "BURBERRY", "GIVENCHY", "MCM", "COACH", "MULBERRY"];

export default function Hero() {
  const { t } = useTranslation();
  const { heading, body } = useLangFont();

  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  const marqueeItems = [...brands, ...brands];

  return (
    <section className="relative w-full min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4ed80a2547a6926a04a4b27c22c506db.jpg"
          alt="大阪自社工房"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A2332]/75 via-[#1A2332]/55 to-[#1A2332]/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A2332]/40 via-transparent to-[#1A2332]/20" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-32 pb-24 flex flex-col items-center text-center">
        <h1
          className="text-5xl md:text-7xl font-bold text-white leading-tight mb-4 tracking-tight"
          style={{ fontFamily: heading }}
        >
          {t("hero_h1")}
          <br />
          <span className="text-[#C9A84C]">{t("hero_h2")}</span>
        </h1>

        <p
          className="text-white/60 text-sm tracking-[0.2em] mb-5"
          style={{ fontFamily: body }}
        >
          {t("hero_badge")}
        </p>

        <p
          className="text-white/75 text-base md:text-lg tracking-wider mb-10 flex flex-wrap justify-center gap-x-4 gap-y-1"
          style={{ fontFamily: body }}
        >
          <span>{t("hero_delivery")}</span>
          <span>{t("hero_speed")}</span>
        </p>

        <div className="w-full overflow-hidden mb-12" style={{ maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)" }}>
          <div className="flex brand-marquee">
            {marqueeItems.map((brand, i) => (
              <span
                key={i}
                className="flex-shrink-0 px-8 text-white/35 hover:text-white/65 transition-colors duration-300 text-xs md:text-sm font-semibold tracking-[0.22em] whitespace-nowrap"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {brand}
              </span>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => handleScroll("#gallery")}
            className="btn-lift inline-flex items-center justify-center gap-2 bg-[#C9A84C] hover:bg-[#B8973B] text-[#1A2332] font-bold text-sm px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: body }}
          >
            {t("hero_btn_gallery")}
            <i className="ri-arrow-down-line text-base" />
          </button>
          <button
            onClick={() => handleScroll("#pricing")}
            className="btn-lift inline-flex items-center justify-center gap-2 border border-white/40 hover:border-[#C9A84C] text-white hover:text-[#C9A84C] text-sm px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: body }}
          >
            {t("hero_btn_pricing")}
          </button>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 animate-bounce">
          <i className="ri-arrow-down-line text-xl" />
        </div>
      </div>
    </section>
  );
}
